import EcoSpace from 'eco-design/base/eco-space';
import ActivityA1 from '../components/ActivityA1';
import ActivityA2 from '../components/ActivityA2';
import ActivityA3 from '../components/ActivityA3';
import BannerA from '../components/BannerA';
import FooterTcA from '../components/FooterTcA';
import ListA1 from '../components/ListA1';
import ListA2 from '../components/ListA2';
import ListB1 from '../components/ListB1';
import ListB2 from '../components/ListB2';
import ListB3 from '../components/ListB3';
import SectionA1 from '../components/SectionA1';
import SectionC1 from '../components/SectionC1';
import SectionC2 from '../components/SectionC2';
import { useProductStore } from '@elem/compPage/wave-3-and-glacier-classic/ProductProvider';
import { IPageStatus } from '@elem/compPage/wave-3-and-glacier-classic/config/IPageStatus';
export default function StatusItem() {
    const { pageStatus } = useProductStore();
    return (
        <>
            <BannerA />
            <SectionA1 />
            <ListA1 />
            <ListB1 />
            <ListB2 />
            <ListB3 />
            <ListA2 />
            <div className="page-section-bg2">
                {pageStatus !== IPageStatus.statusD && <ActivityA1 />}
                <ActivityA2 />
                <ActivityA3 />
                <SectionC1 />
                {pageStatus !== IPageStatus.statusD && <SectionC2 />}
            </div>
            <FooterTcA />
        </>
    );
}
